/* global webpack */

import angular from 'angular'

import { toUrl } from '../utils/security'

angular
  .module('ggs.gallery-campaign')
  .factory('GalleryCampaignStyleHandlers', GalleryCampaignStyleHandlersProvider)

function GalleryCampaignStyleHandlersProvider(
  rootQs,
  GSNApplyStyleTmpl,
  GSNApplyScriptTmpl) {

  const OWNER_TAG = __filename

  return function GalleryCampaignStyleHandlers(blockerAttr) {

    // applyCampaignKey
    // Client side variant of "render partial: 'campaigns/install/overlay_include', locals: {campaign: @gallery.campaign }"

    const CAMPAIGN_SCRIPT_PLH = ':campaignKey:'
    const CAMPAIGN_SCRIPT_TMPL = toUrl(`${webpack.widgetAssetHost}/${CAMPAIGN_SCRIPT_PLH}/ol.js?force=true&no_button=true`)

    const applyCampaignKey = GSNApplyScriptTmpl({
      propKeys: 'campaign_key',
      allowKey: 'allow_entry',
      ownerTag: OWNER_TAG,
      scriptTmpl: CAMPAIGN_SCRIPT_TMPL,
      scriptPlh: CAMPAIGN_SCRIPT_PLH
    })

    // applyButtonBackground

    const BUTTON_BACKGROUND_PLH = ':background:'
    const BUTTON_BACKGROUND_TMPL = `
      ${rootQs} .ggs-gallery-campaign__button {
        background-color: ${BUTTON_BACKGROUND_PLH};
      }`

    const applyButtonBackground = GSNApplyStyleTmpl({
      propKeys: 'campaign_button_color',
      ownerTag: OWNER_TAG,
      styleTmpl: BUTTON_BACKGROUND_TMPL,
      stylePlh: BUTTON_BACKGROUND_PLH
    })

    // applyButtonColor

    const BUTTON_COLOR_PLH = ':color:'
    const BUTTON_COLOR_TMPL = `
      ${rootQs} .ggs-gallery-campaign__text {
        color: ${BUTTON_COLOR_PLH};
      }`

    const applyButtonColor = GSNApplyStyleTmpl({
      propKeys: 'campaign_button_text_color',
      ownerTag: OWNER_TAG,
      styleTmpl: BUTTON_COLOR_TMPL,
      stylePlh: BUTTON_COLOR_PLH
    })

    // applyFocusableCloseButton

    const FOCUSABLE_CLOSE_BUTTON_CONST = `
      /* allowed to skip the rootQs */
      [${blockerAttr}] #c9-close-blocker:focus::before {
        content: " ";
        position: absolute;
        top: 4px;
        right: 6px;
        bottom: 1px;
        left: -3px;
        border: 1px solid #fff;
        opacity: 0.3;
        border-radius: 4px;
      }`

    const applyFocusableCloseButton = GSNApplyStyleTmpl({
      allowKey: 'campaign_focusable_close_button',
      ownerTag: OWNER_TAG,
      styleConst: FOCUSABLE_CLOSE_BUTTON_CONST
    })

    // return

    return [
      applyCampaignKey,
      applyButtonColor,
      applyButtonBackground,
      applyFocusableCloseButton
    ]
  }
}
